import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import { PriceBreakdownContent } from 'dpl/common/components/PriceBreakdownModal';

import WhatsIncluded from '../shared/WhatsIncluded';

export default function PricingMobileMenu({ isOpen, closeModal }) {
  const {
    priceBreakdown,
    acceptsBnplPayments,
    depositRefundPolicy,
    depositDescription
  } = useSelector(({ server }) => server);

  return (
    <FixedTooltipPortal
      className="PricingMobileMenu ph5 bg-white no-scrollbars b--transparent"
      isVisible={isOpen}
      onCloseClick={closeModal}
      style={{ maxHeight: '85vh' }}
    >
      {priceBreakdown && (
        <>
          <h4 className="font-24 lh-title mt4 mb6">Price breakdown</h4>
          <PriceBreakdownContent
            className="br12 ba b--default ph4 mb4"
            deposit={priceBreakdown.deposit}
            depositDescription={depositDescription}
            depositRefundPolicy={depositRefundPolicy}
            dogPayment={priceBreakdown.dog_payment}
            subtotal={priceBreakdown.subtotal}
            isBnplAvailable={acceptsBnplPayments}
          />
        </>
      )}
      <WhatsIncluded className="pt4" />
    </FixedTooltipPortal>
  );
}

PricingMobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};
